<template>
  <div class="mainContainer">
    <div class="gbgTruckCardsScenario">
      <div class="trucksCardScenario">
        <div class="truckList">
          <div class="listHeader">
            <label class="headerLabel">TRUCK LIST</label>
            <div class="inputContainer">
              <input type="text" placeholder="Search Truck..." v-model="searchQ" class="truckInput">
            </div>

          </div>
          <div class="listContainer">
            <div class="listContent">
              <div v-for="item2 in items2" :key="item2.frameNumber" class="listItem"
                v-on:click="goToTruckDetail(item2.frameNumber)">
                <span class="itemText" v-on:click="goToTruckDetail(item2.frameNumber)">Truck {{ item2.frameNumber
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="trucksContainer">
          <div class="truckContainer" v-for="item in items" :key="item.id">
            <div class="dataContainer">
              <div>
                <div>
                  <b><strong>FRAME NUMBER:</strong></b> {{ item.frameNumber }}
                </div>
                <div>
                  <b><strong>FUEL:</strong></b> {{ item.fuel }}
                </div>
                <div>
                  <b><strong>CAPACITY:</strong></b> {{ item.capacity }}/{{ item.totalCapacity }} KG
                </div>
                <div class="onRouteContainer">
                  <b><strong>ON ROUTE:</strong></b> <img v-if="item.onRoute"
                    src="@/assets/scenarios/garbage/truck/onRoute.png"><img v-if="!item.onRoute"
                    src="@/assets/scenarios/garbage/truck/notOnRoute.png">
                </div>
              </div>

              <div class="garbageClsContainer">
                <strong>GARBAGE CLASS: </strong>
                <img v-if="item.garbageClass == 'organic'" src="@/assets/scenarios/garbage/truck/organic.png" width="40px"
                  height="40px">
                <img v-if="item.garbageClass == 'plastic'" src="@/assets/scenarios/garbage/truck/plastic.png" width="40px"
                  height="40px">
                <img v-if="item.garbageClass == 'paper'" src="@/assets/scenarios/garbage/truck/paper.png" width="40px"
                  height="40px">
              </div>

            </div>
            <div class="actionsContainer">
              <v-btn rounded class="actionButton">Start route</v-btn>
              <v-btn rounded class="actionButton">Empty truck</v-btn>
              <v-btn rounded class="actionButton">Set ready</v-btn>
              <v-btn rounded class="actionButton">Refill fuel</v-btn>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import trucksGarbageIIOTAPI from '@/services/trucksGarbageIIOTAPI';

export default {
  name: "TruckCards",
  data() {
    return {
      items: [

      ],
      searchQ: "",
      items2: [

      ],
    };
  },
  watch: {
    searchQ: function () {
      console.log(this.searchQ);
      this.items2 = this.items.filter(item => { return item.frameNumber.includes(this.searchQ) })
    }
  },
  methods: {
    goToTruckDetail(frameNumber) {
      this.$router.push('/scenarios/iiot/trucks/' + frameNumber)
    }
  },
  beforeMount() {
    trucksGarbageIIOTAPI.get('/property/fleetDetails').then(async (res) => {
      this.items = res.data;
      this.items2 = res.data;
    });
  }

}
</script>
<style scoped>
.mainContainer {
  display: grid;
  place-items: center;
  height: 100%;
}

.gbgTruckCardsScenario {
  display: grid;
  place-items: center;
  background-color: #F6F6F6;
  border-radius: 12px;
  padding: 0rem 0rem 0rem 0rem;
  margin: 1rem 0;
  border: 1px solid #AAA;
  
}

.truckContainer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 385px;
  height: 256px;
  background-color: #25262D;
  margin: 20px;
}

.actionsContainer {
  margin: 0.8rem;
  display: grid;
  place-items: center;
}

.actionButton {
  color: black;
  background-color: #D9D9D9;
  width: 100%;
  font-weight: bold;
}

.dataContainer {
  color: white;
  margin: 0.8rem;
  margin-bottom: 0;
  display: grid;
  justify-content: space-between;
}

.trucksContainer {
  background-color: #F6F6F6;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  place-items: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
} 

.onRouteContainer {
  display: flex;
  align-items: center;
}

.onRouteContainer img {
  margin-left: 10px;
}

.garbageClsContainer {
  display: flex;
  align-items: center;
  font-size: xx-small;
  margin-bottom: -30px;
}

.garbageClsContainer img {
  margin: 10px;
}

.trucksCardScenario {
  display: grid;
  grid-template-columns: 1fr 7fr;
  height: 100%;
  max-width: 1150px;
  
}

.truckList {
  background-color: #DDDFE3;
  display: grid;
  grid-template-rows: 10% 90%;
  place-items: center;
  height: 100%;
  width: 100%;
  border-right: 1px solid #BBB;
  border-left: 1px solid #BBB;
}

.listHeader {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  background-color: #B0B5BF;
}

.listContent {
  display: grid;
  place-items: center;
  width: 100%;
}

.listContent>div:nth-child(even) {
  background-color: #D9D9D9;
}

.listContent>div:nth-child(odd) {
  background-color: #C6C6C6;
}

.listContent>div {
  padding: 0.4rem;
  cursor: pointer;
}

.listItem {
  width: 100%;
}

.itemText {
  font-weight: 500;
  font-size: 1.2rem;
  color: #63635B;
  margin: 1rem;
}

.inputContainer {
  background-color: white;
  border-radius: 24px;
  margin-bottom: 10px;
  text-align: start;
  display: grid;
  place-items: center;
  padding-left: 10px;
  height: 60%;
  width: 80%;
}

.truckInput {
  font-weight: 500;
}

.headerLabel {
  font-weight: 700;
  font-size: 1.2rem;
  color: #FFF;
}

.listContainer {
  width: 100%;
  height: 100%;
}</style>